import React from 'react';
import { compose, map, propOr, sortBy, indexOf, keys, toPairs, prop } from 'ramda';
import { InputNumber } from 'antd';
import { ExpandOutlined } from '@ant-design/icons';
import { Components } from '@fasstech/flexiget';

const translatePadding = {
  top: 'Haut',
  right: 'Droit',
  bottom: 'Bas',
  left: 'Gauche'
};

const PaddingInfo = ({ updatePadding, element, userCanEdit }) => (
  <div className="w-full items-center flex justify-between mb-2">
    <Components.Tooltip
      title="Gestion du padding"
    >
      <ExpandOutlined />
    </Components.Tooltip>
    {compose(
      map(([key, paddingType]) => {
        return (
          <div key={key} className="flex">
            <p className="mr-2">{propOr('', key, translatePadding)}</p>
            <InputNumber
              onChange={(value) => updatePadding(key, value)}
              value={paddingType}
              defaultValue={0}
              min={0}
              size="small"
              formatter={value => `${value}px`}
              parser={value => value.replace('px', '')}
              disabled={!userCanEdit}
            />
          </div>
        );
      }),
      sortBy(([key]) => indexOf(key, keys(translatePadding))),
      toPairs
    )(prop('padding', element))}
  </div>
);

export default PaddingInfo;
